"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardKpiPlaceholderWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var widgets_1 = require("../../../widgets");
var model_1 = require("../../../model");
var presentationComponents_1 = require("../../presentationComponents");
var common_1 = require("../common");
var KpiPlaceholderConfigurationPanel_1 = require("./KpiPlaceholderConfigurationPanel");
/**
 * @internal
 */
exports.DefaultDashboardKpiPlaceholderWidget = function (props) {
    var widget = props.widget, screen = props.screen;
    ts_invariant_1.default(widgets_1.isKpiPlaceholderWidget(widget));
    var dispatch = model_1.useDashboardDispatch();
    var _a = model_1.useDashboardSelector(model_1.selectWidgetCoordinatesByRef(widget.ref)), itemIndex = _a.itemIndex, sectionIndex = _a.sectionIndex;
    var _b = model_1.useWidgetSelection(widget.ref), isSelectable = _b.isSelectable, isSelected = _b.isSelected;
    // keep information if this widget has been selected in the past
    var wasSelected = react_1.useRef(isSelected);
    react_1.useEffect(function () {
        if (isSelected) {
            wasSelected.current = true;
        }
    }, [isSelected]);
    react_1.useEffect(function () {
        // if the widget was selected in the past and is now not selected, it has just been unselected
        // -> remove its widget placeholder
        if (wasSelected.current && !isSelected) {
            dispatch(model_1.eagerRemoveSectionItem(sectionIndex, itemIndex));
        }
    }, [dispatch, isSelected, itemIndex, sectionIndex]);
    var onClose = react_1.useCallback(function () {
        dispatch(model_1.uiActions.setConfigurationPanelOpened(false));
        dispatch(model_1.eagerRemoveSectionItem(sectionIndex, itemIndex));
    }, [dispatch, itemIndex, sectionIndex]);
    return (react_1.default.createElement(presentationComponents_1.DashboardItem, { className: "is-selected is-placeholder is-edit-mode", screen: screen },
        react_1.default.createElement(presentationComponents_1.DashboardItemContent, { isSelected: isSelected, isSelectable: isSelectable },
            react_1.default.createElement(common_1.ConfigurationBubble, { onClose: onClose },
                react_1.default.createElement(KpiPlaceholderConfigurationPanel_1.KpiPlaceholderConfigurationPanel, { widget: widget, onClose: onClose })),
            react_1.default.createElement("div", { className: "kpi-placeholder select-measure" }))));
};
//# sourceMappingURL=DefaultDashboardKpiPlaceholderWidget.js.map